<template>
    <div class="col-lg-9">

        <!-- Personal Details ============================================= -->
        <div class="bg-light shadow-sm rounded p-4 mb-4">
            <h3 class="text-5 font-weight-400 mb-3">Personal Details <a href="#edit-personal-details" data-toggle="modal" class="float-right text-1 text-uppercase text-muted btn-link"><i class="fas fa-edit mr-1"></i>Edit</a></h3>
            <profile-view></profile-view>
        </div>
        <!-- Edit Details Modal ================================== -->
        <div id="edit-personal-details" class="modal fade " role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-400">Personal Details</h5>
                        <button type="button" class="close font-weight-400" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
                    </div>
                    <div class="modal-body p-4">
                        <profile-edit></profile-edit>
                    </div>
                </div>
            </div>
        </div>
        <!-- Personal Details End -->

        <!-- Security ============================================= -->
        <div class="bg-light shadow-sm rounded p-4">
            <h3 class="text-5 font-weight-400 mb-3">Security <a href="#change-password" data-toggle="modal" class="float-right text-1 text-uppercase text-muted btn-link"><i class="fas fa-edit mr-1"></i>Edit</a></h3>
            <div class="row">
                <p class="col-sm-3 text-muted text-sm-right mb-0 mb-sm-3">
                    <label class="col-form-label">Password</label>
                </p>
                <p class="col-sm-9">
                    <input type="password" class="form-control-plaintext" data-bv-field="password" id="password" value="EnterPassword">
                </p>
            </div>
        </div>
        <!-- Edit Details Modal
        ================================== -->
        <div id="change-password" class="modal fade " role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-400">Change Password</h5>
                        <button type="button" class="close font-weight-400" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
                    </div>
                    <div class="modal-body p-4">
                        <profile-password></profile-password>
                    </div>
                </div>
            </div>
        </div>
        <!-- Security End -->

    </div>
</template>

<script>
    export default {
        name: "Index",
        components: {
            ProfileView: () => import('./View.vue'),
            ProfileEdit: () => import('./Edit.vue'),
            ProfilePassword: () => import('./Password.vue'),
        }
    }
</script>

<style scoped>

</style>
